import React, { Component } from "react";
import up from "../../../../assets/icons/vector_up.svg";
import down from "../../../../assets/icons/vector_down.svg";
import "../styles/global.css";
import { Button } from "react-bootstrap";

class ValueInc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerValue: 100
    };
  }

  resetValues = () => {
    this.setState({
      headerValue: this.props.default
    })
  }

  inc = () => {
    let val = parseFloat(this.state.headerValue) + this.props.incBy
    this.setState({
      headerValue: val
    }, this.props.func1(val));
  };

  onChange = e => {
    if (e.target.value) {
      this.setState({
        headerValue: parseFloat(e.target.value)
      }, this.props.func1(parseFloat(e.target.value)));
    } else  {
      this.setState({
        headerValue: 0
      });
    }
  };

  dec = () => {
    if (this.state.headerValue - this.props.incBy > this.props.min) {
      let val = parseFloat(this.state.headerValue) - this.props.incBy
      this.setState({
        headerValue: val
      }, this.props.func1(val));
    }
  };

  componentWillMount() {    
    this.setState({
      headerValue: this.props.default
    });
  }
  render() {
    let { headerValue } = this.state;
    headerValue = headerValue.toFixed(this.props.decimal);
    return (
      <div className="dd-wrapper" style={{ width: this.props.width }}>
        <div className="dd-header">
          <div>
            <input
              id="incBox"
              type="number"
              placeholder={headerValue}
              style={{
                width: "100%",
                backgroundColor: "#F9F9FA",
                borderRadius: "3px",
                border: "1px solid #F9F9FA",
                paddingLeft: "5px",
                fontWeight: "normal",
                color: "#9A9DA0"
              }}
              min={this.props.min}
              step={this.props.incBy}
              value={headerValue}
              onChange={this.onChange}
            />
          </div>
          <div
            style={{
              backgroundColor: "#17D9AA",
              borderRadius: "3px",
              border: "1px solid #17D9AA"
            }}
          >
            <center>
              <img
                onClick={this.inc}
                style={{
                  backgroundColor: "#17D9AA",
                  padding: "3px"
                }}
                src={up}
              />
              <br></br>
              <img
                onClick={this.dec}
                style={{
                  backgroundColor: "#17D9AA",
                  padding: "3px"
                }}
                src={down}
              />
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default ValueInc;
